import React from "react";
import { useState, useEffect } from "react";
//import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import OutlinedInput from "@mui/material/OutlinedInput";
import moment from "moment"; // Getting day from date and modifying date format
import toast from "react-hot-toast";
import { toastStyle } from "../../utility/helper";
import "react-phone-number-input/style.css";
import PhoneInput, {
  isValidPhoneNumber,
  formatPhoneNumberIntl,
} from "react-phone-number-input";
import axios from "axios";
import { TextField } from "@mui/material";
import TimePreference from "./TimePreference/TimePreference";
// Properties for controlling drop down menu height and width in Select Component
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const InterviewerProfileForm = () => {
  // On loading the page, it'll start displaying from specific location of the page
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // To set and handle the profile preference to interviewer profile preference
  const [profile, setProfile] = React.useState([]);
  // Adding and removing of items in the profiles
  const handlePrefChange = (event) => {
    const {
      target: { value },
    } = event;
    setProfile(typeof value === "string" ? value.split(",") : value);
  };
  // To delete selected profiles explicitly from the selection list
  const handleDelete = (label) => {
    setProfile(
      profile.filter(function (item) {
        return item !== label;
      })
    );
  };

  // Form Data
  const [inputs, setInputs] = useState({
    dfname: JSON.parse(localStorage.getItem("isIAuthenticated")).username.split(
      " "
    )[0],
    dlname: JSON.parse(localStorage.getItem("isIAuthenticated")).username.split(
      " "
    )[1],
    email: JSON.parse(localStorage.getItem("isIAuthenticated")).email,
    mobNumber: "",
    designation: "",
    company: "",
    location: "",
    gradInsti: "",
    gradYear: "",
    profilePreference: [],
    paymentPref: "",
    accNo: "",
    ifsc: "",
    bankName: "",
    branchCode: "",
    desc: "",
    dp: JSON.parse(localStorage.getItem("isIAuthenticated")).thumbNail,
    linkedInURL: "",
    githubURL: "",
    twitterURL: "",
    slotTime: [],
  });
  const [pfpImage, setpfpImage] = useState(null);

  // Handling Change in the form "inputs" state variable
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    // Append the property if doesn't exist and if does then update
    setInputs({ ...inputs, [name]: value });
  };
  // Text Value state varible is used to enter institute name manually
  const [textValue, setTextValue] = useState("");

  // Mobile Number with Country Code
  const [countryCodeMobileNo, setCountryCodeMobileNo] = useState();

  // const [years, setYears] = useState([]);
  const institutes = [
    "DCRUST Murthal",
    "IIT Bhilai",
    "IIT (BHU) Varanasi",
    "IIT Bhubaneswar",
    "IIT Bombay",
    "IIT Delhi",
    "IIT (ISM) Dhanbad",
    "IIT Dharwad",
    "IIT Gandhinagar",
    "IIT Goa",
    "IIT Guwahati",
    "IIT Hyderabad",
    "IIT Indore	",
    "IIT Jammu",
    "IIT Kanpur",
    "IIT Kharagpur",
    "IIT Madras",
    "IIT Mandi",
    "IIT Jodhpur",
    "IIT Palakkad",
    "IIT Patna",
    "IIT Roorkee",
    "IIT Ropar",
    "IIT Tirupati",
  ];

  // Year of Graduated Institute
  const years = [];
  for (let year = 2022; year >= 1955; year--) {
    years.push(year);
  }
  // -------

  // Input fields Error Handling and Disabling
  const [fieldError, setFieldError] = useState({
    gradInsti: false,
    gradInstiManual: false,
    gradInstiManualDisabled: false,
    gradYear: false,
    profile: false,
    paymentPref: false,
  });

  /*  
    To convert 12 Hour Time format to 24 Hours Decimal format(for ease of processing in backend)
    E.g. 12:15 AM -> 0.25, 01:45 PM -> 13.75
  */
  const t12HTo24HDecimalFormat = (time12) => {
    let time = moment(time12, "hh:mm A").format("HH:mm");
    if (time === "23:59") return 24;
    let h = Number(time.split(":")[0]);
    let m = Number(time.split(":")[1]) * (5 / 3);
    return Number(`${h}.${parseFloat(m)}`);
  };

  // HandleSubmit
  const handleSubmit = (e) => {
    e.preventDefault();

    // Checking all the fields to be filled and should follow the rules
    if (!inputs.dfname) {
      let box = document.getElementById("dfname");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // window.alert("Please enter your first name!");
      return box.focus();
    }
    if (!inputs.dlname) {
      let box = document.getElementById("dlname");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // return window.alert("Please enter your last name!");
      // return;
    }
    if (!inputs.email.endsWith("@gmail.com")) {
      let box = document.getElementById("email-field");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // return window.alert("Please enter a valid Gmail address!");
      return box.focus();
    }
    if (!(countryCodeMobileNo && isValidPhoneNumber(countryCodeMobileNo))) {
      let box = document.getElementById("phone-no");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      return box.focus();
    }
    if (!inputs.designation) {
      let box = document.getElementById("designation");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // return window.alert("Please enter your designation!");
      return box.focus();
    }
    if (!inputs.company) {
      let box = document.getElementById("company");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // return window.alert("Please enter your designation!");
      return box.focus();
    }
    if (!inputs.location) {
      let box = document.getElementById("location");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // return window.alert("Please enter your location!");
      return box.focus();
    }
    if (!inputs.gradInsti) {
      setFieldError({ ...fieldError, gradInsti: true });
      let box = document.getElementById("gradInsti");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // return window.alert("Please enter where you graduated from!");
      return box.focus();
    }
    if (!inputs.gradYear) {
      setFieldError({ ...fieldError, gradYear: true });
      let box = document.getElementById("gradYear");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // return window.alert("Please enter when you graduated in!");
      return box.focus();
      // return;
    }
    if (profile.length === 0) {
      setFieldError({ ...fieldError, profile: true });
      let box = document.getElementById("profile");
      // box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // return window.alert("Please enter your profile preference!");
      return box.focus();
    }
    if (!inputs.paymentPref) {
      setFieldError({ ...fieldError, paymentPref: true });
      let box = document.getElementById("paymentPref");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // return window.alert("Please enter your payment preference!");
      return box.focus();
    }
    if (!inputs.linkedInURL) {
      let box = document.getElementById("linkedin");
      box.style.borderColor = "#FF0000";
      window.scrollTo(box.offsetTop, box.offsetTop);
      // return window.alert("Please enter your LinkedIn URL!");
      return box.focus();
    }

    const userData = {
      dfname: inputs.dfname,
      dlname: inputs.dlname,
      email: inputs.email,
      mobNumber: formatPhoneNumberIntl(countryCodeMobileNo),
      designation: inputs.designation,
      company: inputs.company,
      location: inputs.location,
      gradInsti: inputs.gradInsti,
      gradYear: inputs.gradYear,
      profilePreference: "profile",
      paymentPref: inputs.paymentPref,
      accNo: inputs.accNo,
      ifsc: inputs.ifsc,
      bankName: inputs.bankName,
      branchCode: inputs.branchCode,
      desc: inputs.desc,
      linkedInURL: inputs.linkedInURL,
      githubURL: inputs.githubURL,
      twitterURL: inputs.twitterURL,
      // slotTime:daysBol
    };
    console.log(userData);
    // if (
    //   slotwiseGenericSchd ===
    //   {
    //     mon: [],
    //     tue: [],
    //     wed: [],
    //     thu: [],
    //     fri: [],
    //     sat: [],
    //     sun: [],
    //   }
    // ) {
    //   return alert("Enter time preference");
    // } else {
    //   let tempArr = {
    //     mon: [],
    //     tue: [],
    //     wed: [],
    //     thu: [],
    //     fri: [],
    //     sat: [],
    //     sun: [],
    //   };
    //   Object.keys(slotwiseGenericSchd).forEach((item) => {
    //     slotwiseGenericSchd[item]?.forEach((anoItem) => {
    //       tempArr[item].push([
    //         t12HTo24HDecimalFormat(anoItem.final[0]),
    //         t12HTo24HDecimalFormat(anoItem.final[1]),
    //       ]);
    //     });
    //   });
    //   setFinalGenericSchdArray(tempArr);
    // }

    console.log(inputs);
    console.log("userData");
    console.log(userData);

    axios
      .patch(
        `http://localhost:8585/send/iprofile/${
          JSON.parse(localStorage.getItem("isIAuthenticated")).Id
        }`,
        userData
      )
      .then((response) => {
        console.log(response.status);
        console.log(response.data);
      });
    window.alert("Your Details will be updated?");
  };

  // Thanks Greeting for Payment method when selected to Alumin Association
  const [openThanksGreeting, setOpenThanksGreeting] = useState(false);
  const handleThanksGreetingOpen = () => setOpenThanksGreeting(true);
  const handleThanksGreetingClose = () => setOpenThanksGreeting(false);
  const styleOfGreeting = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <div className="profile-form py-1">
        <Typography
          variant="h4"
          component="h4"
          sx={{ fontWeight: "bold", color: "#29ab87", padding: "0px 20px" }}
        >
          Create an Account as Professional
        </Typography>
        <form onSubmit={handleSubmit}>
          {/* Profile Form Container */}

          <div className="profile-form-cont">
            {/* Col-70 */}

            <div className="profile-form-text">
              {/* First Name and Last Name */}

              <div className="name cust-row flex">
                <div className="element">
                  <label htmlFor="firstname">
                    First Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="dfname"
                    id="dfname"
                    className="border-2 rounded"
                    value={inputs.dfname}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    placeholder="First Name"
                    style={{ height: "56px" }}
                  />
                </div>
                <div className="element">
                  <label htmlFor="lastname">
                    Last Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="dlname"
                    id="dlname"
                    className="border-2 rounded"
                    value={inputs.dlname}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    placeholder="Last Name"
                    style={{ height: "56px" }}
                  />
                </div>
              </div>

              {/* Email and Mobile Number */}

              <div className="email cust-row flex">
                <div className="element">
                  <label htmlFor="email">
                    Email (only Gmail)<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email-field"
                    className="border-2 rounded"
                    value={inputs.email}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    placeholder="Email"
                    style={{ height: "56px" }}
                  />
                </div>
                <div className="element">
                  <label htmlFor="number">
                    WhatsApp Number<span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="border-2 rounded px-3" id="phone-no">
                    <PhoneInput
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="IN"
                      value={countryCodeMobileNo}
                      onChange={(e) => {
                        document.getElementById("phone-no").style.borderColor =
                          "#e5e7eb";
                        setCountryCodeMobileNo(e);
                      }}
                      error={
                        countryCodeMobileNo
                          ? isValidPhoneNumber(countryCodeMobileNo)
                            ? undefined
                            : "Invalid phone number"
                          : "Phone number required"
                      }
                    />
                  </div>
                </div>
              </div>

              {/* Company and Organisation */}
              <div className="email cust-row flex">
                <div className="element">
                  <label htmlFor="desg">
                    Designation<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="designation"
                    id="designation"
                    className="border-2 rounded"
                    value={inputs.designation}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    placeholder="Position"
                    style={{ height: "56px" }}
                  />
                </div>
                <div className="element">
                  <label htmlFor="org">
                    Company/Organization<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="company"
                    id="company"
                    className="border-2 rounded"
                    value={inputs.company}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    placeholder="Company/Organization"
                    autoComplete="nope"
                    style={{ height: "56px" }}
                  />
                </div>
              </div>

              {/* Location */}
              <div className="email cust-row flex">
                <div className="element">
                  <label htmlFor="location">
                    Location<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="location"
                    name="location"
                    id="location"
                    className="border-2 rounded"
                    value={inputs.location}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    placeholder="City"
                    autoComplete="nope"
                    style={{
                      height: "56px",
                      maxWidth: "355px",
                      display: "block",
                    }}
                  />
                </div>
              </div>

              {/* Graduated From */}
              <div
                className="branch cust-row flex"
                style={{ alignItems: "flex-start" }}
              >
                <div className="element">
                  <label htmlFor="institute">
                    Graduated from
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    value={inputs.gradInsti}
                    name="gradInsti"
                    id="gradInsti"
                    error={fieldError.gradInsti}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldError({ ...fieldError, gradInsti: false });
                    }}
                    displayEmpty
                    MenuProps={MenuProps}
                    sx={{ width: 1 }}
                    inputProps={{ "aria-label": "Without label" }}
                    style={{ textOverflow: "ellipsis" }}
                  >
                    <MenuItem hidden disabled value="">
                      Select Institute
                    </MenuItem>
                    <MenuItem value="manual">
                      <p className="text-blue-500 italic">
                        Enter Institute Manually
                      </p>
                    </MenuItem>
                    {institutes?.map((item) => {
                      return (
                        <MenuItem key={`grad${item}`} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {inputs.gradInsti === "manual" ? (
                    <Box
                      component="form"
                      noValidate
                      autoComplete="off"
                      sx={{
                        width: 1,
                        gap: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "4px 0px",
                        marginTop: "4px",
                      }}
                    >
                      <OutlinedInput
                        placeholder="Enter Institute Here"
                        id="manualInst"
                        disabled={fieldError.gradInstiManualDisabled}
                        error={fieldError.gradInstiManual}
                        value={textValue}
                        onChange={(e) => {
                          setTextValue(e.target.value);
                          setFieldError({
                            ...fieldError,
                            gradInstiManual: false,
                          });
                        }}
                      />
                      <Button
                        variant="contained"
                        hidden
                        sx={{ width: 0.25 }}
                        onClick={(e) => {
                          if (!fieldError.gradInstiManualDisabled) {
                            setInputs({ ...inputs, manualInst: textValue });
                          }
                          setFieldError({
                            ...fieldError,
                            gradInstiManualDisabled:
                              !fieldError.gradInstiManualDisabled,
                          });
                        }}
                      >
                        {fieldError.gradInstiManualDisabled ? "Edit" : "Save"}
                      </Button>
                    </Box>
                  ) : null}
                </div>
                <div className="element">
                  <label htmlFor="year">
                    Graduated in
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    value={inputs.gradYear}
                    name="gradYear"
                    id="gradYear"
                    error={fieldError.gradYear}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldError({ ...fieldError, gradYear: false });
                    }}
                    displayEmpty
                    MenuProps={MenuProps}
                    sx={{ width: 1 }}
                    inputProps={{ "aria-label": "Without label" }}
                    style={{ textOverflow: "ellipsis" }}
                  >
                    <MenuItem hidden disabled value="">
                      Select Year
                    </MenuItem>
                    {years?.map((year) => {
                      return (
                        <MenuItem key={`grad${year}`} value={year}>
                          {year}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </div>
              </div>

              {/* Profile Preference */}

              <div className="profilepref cust-row flex">
                <div className="element">
                  <label htmlFor="profile">
                    Profile Preferences<span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="flex gap-5">
                    <Select
                      multiple
                      displayEmpty
                      id="profile"
                      value={profile}
                      error={fieldError.profile}
                      sx={{ width: 1 }}
                      renderValue={() => "Select Preferences"}
                      onChange={(e) => {
                        handlePrefChange(e);
                        setFieldError({ ...fieldError, profile: false });
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="Data Science">Data Science</MenuItem>
                      <MenuItem value="Software">Software</MenuItem>
                      <MenuItem value="Banking and Finance">
                        Banking and Finance
                      </MenuItem>
                      <MenuItem value="Consulting">Consulting</MenuItem>
                      <MenuItem value="Analytics">Analytics</MenuItem>
                      <MenuItem value="Product Management">
                        Product Management
                      </MenuItem>
                    </Select>
                    <div className="profile-pref-list rounded p-2">
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {profile.map((value) => (
                          <Chip
                            key={value}
                            label={value}
                            onDelete={() => {
                              handleDelete(value);
                            }}
                          />
                        ))}
                      </Box>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contribution */}
              <div className="email border-2 rounded border-green-600 px-1 py-2">
                <div className="element ">
                  <p className="text-lg">
                    For each successfully completed Mock Interview (with
                    Feedback Session), an amount of INR 250 is paid by the
                    student for you. Would you like to keep it with you, or
                    donate it to IIT Madras Alumni Association for welfare of
                    IIT Madras?
                  </p>
                  <p className="mt-2 text-blue-500">
                    Choose your payment preference
                    <span style={{ color: "red" }}>*</span>
                  </p>
                  <Select
                    value={inputs.paymentPref}
                    name="paymentPref"
                    id="paymentPref"
                    error={fieldError.paymentPref}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldError({ ...fieldError, paymentPref: false });
                    }}
                    displayEmpty
                    MenuProps={MenuProps}
                    sx={{ width: 0.5 }}
                    inputProps={{ "aria-label": "Without label" }}
                    style={{ textOverflow: "ellipsis" }}
                  >
                    <MenuItem hidden disabled value="">
                      Select Payment Preference
                    </MenuItem>
                    <MenuItem value="self">Opt for Self</MenuItem>
                    <MenuItem value="donate" onClick={handleThanksGreetingOpen}>
                      Donate to your IIT Alumni Association
                    </MenuItem>
                  </Select>
                  {inputs.paymentPref === "self" ? (
                    <>
                      <div className="element" id="addAc">
                        <Typography
                          variant="h6"
                          component="h6"
                          style={{
                            marginTop: "12px",
                            fontFamily: "'Ubuntu', sans-serif",
                            color: "rgb(59 130 246)",
                          }}
                        >
                          Add Bank Account details
                        </Typography>
                        <div className="flex gap-5">
                          <div className="element">
                            <label htmlFor="acno">
                              Account Number
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              name="accNo"
                              id="accNo"
                              className="border-2 rounded"
                              value={inputs.accNo}
                              onChange={(e) => {
                                e.target.style.borderColor = "#e5e7eb";
                                handleChange(e);
                              }}
                              placeholder="Account Number"
                              autoComplete="nope"
                              style={{
                                height: "56px",
                              }}
                            />
                          </div>
                          <div className="element">
                            <label htmlFor="ifsc">
                              IFSC<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              name="ifsc"
                              id="ifsc"
                              className="border-2 rounded"
                              value={inputs.ifsc}
                              onChange={(e) => {
                                e.target.style.borderColor = "#e5e7eb";
                                handleChange(e);
                              }}
                              placeholder="IFSC"
                              autoComplete="nope"
                              style={{
                                height: "56px",
                              }}
                            />
                          </div>
                        </div>
                        <div className="flex gap-5 mt-4">
                          <div className="element">
                            <label htmlFor="bankname">
                              Name of the Bank
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              name="bankName"
                              id="bankName"
                              className="border-2 rounded"
                              value={inputs.bankName}
                              onChange={(e) => {
                                e.target.style.borderColor = "#e5e7eb";
                                handleChange(e);
                              }}
                              placeholder="Name of the Bank"
                              autoComplete="nope"
                              style={{
                                height: "56px",
                              }}
                            />
                          </div>
                          <div className="element">
                            <label htmlFor="acno">
                              Branch Code
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              name="branchCode"
                              id="branchCode"
                              className="border-2 rounded"
                              value={inputs.branchCode}
                              onChange={(e) => {
                                e.target.style.borderColor = "#e5e7eb";
                                handleChange(e);
                              }}
                              placeholder="Branch Code"
                              autoComplete="nope"
                              style={{
                                height: "56px",
                              }}
                            />
                          </div>
                        </div>
                        <div className="element mt-4 mb-2 flex justify-center">
                          <Button variant="contained">save</Button>
                        </div>
                      </div>
                    </>
                  ) : null}
                  <Modal
                    open={openThanksGreeting}
                    onClose={handleThanksGreetingClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={styleOfGreeting}>
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        Text in a modal
                      </Typography>
                      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        Duis mollis, est non commodo luctus, nisi erat porttitor
                        ligula.
                      </Typography>
                    </Box>
                  </Modal>
                </div>
              </div>

              {/* Description */}
              <div className="profilepref cust-row flex">
                <div className="element">
                  <label htmlFor="desc">Description</label>
                  <textarea
                    name="desc"
                    id="desc"
                    cols="30"
                    rows="6"
                    value={inputs.desc}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    placeholder="Tell us about yourself"
                    className="border p-1 focus:outline-none resize-none"
                  ></textarea>
                </div>
              </div>
            </div>

            {/* Col-30 */}

            <div className="profile-form-profile">
              {/* Profile Photo */}

              <div className="profile-photo border rounded-md p-2">
                <Typography
                  variant="h5"
                  component="h5"
                  style={{
                    margin: "10px",
                    fontFamily: "'Ubuntu', sans-serif",
                  }}
                >
                  Profile Photo
                </Typography>
                <img src={inputs.dp} className="upload" alt="Upload" />
                <input
                  type="file"
                  name="dp"
                  id="dp"
                  className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100"
                  value={""}
                  // required
                  accept="image/png, image/jpg, image/jpeg, image/url"
                  onChange={(e) => {
                    const value = e.target.files[0];
                    console.log(value);
                    setpfpImage({ pfpImage: value });
                    console.log(pfpImage.pfpImage);
                    var image = document.querySelector(".upload");
                    image.src = URL.createObjectURL(e.target.files[0]);
                  }}
                />
              </div>
              <button
                onClick={() => {
                  const imageData = {
                    name: "pfpImage.name",
                    testImage: pfpImage.pfpImage,
                  };
                  // console.log(pfpImage.name)
                  console.log(imageData);
                  const fd = new FormData();
                  fd.append("name", imageData.name);
                  fd.append("testImage", pfpImage.pfpImage);
                  console.log(fd);
                  axios
                    .post(`${process.env.REACT_APP_SERVER_URL}/pfpupload`, fd)
                    .then((response) => {
                      toast.success("Image Uploaded Successfully", {
                        ...toastStyle.success,
                      });
                      console.log(response);
                    })
                    .catch((error) => {
                      toast.error("Error occured while Uploading...", {
                        ...toastStyle.error,
                      });
                      console.log("ERROR");
                      console.log(error);
                    });
                }}
              >
                Upload
              </button>
              <div className="my-3 p-2 border rounded-md text-left">
                <Typography
                  variant="h5"
                  component="h5"
                  align="center"
                  style={{ margin: "10px", fontFamily: "'Ubuntu', sans-serif" }}
                >
                  Social Links
                </Typography>
                <div className="my-3">
                  <label htmlFor="linkedin">
                    <i className="fa-brands fa-linkedin"></i> LinkedIn
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="url"
                    name="linkedInURL"
                    id="linkedin"
                    value={inputs.linkedInURL}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                    placeholder="LinkedIn URL"
                  />
                </div>
                <div className="my-3">
                  <label htmlFor="github">
                    <i class="fa-brands fa-github"></i> GitHub
                  </label>
                  <input
                    type="url"
                    name="githubURL"
                    id="githubURL"
                    value={inputs.githubURL}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                    placeholder="GitHub URL"
                  />
                </div>
                <div className="my-3">
                  <label htmlFor="twitter">
                    <i class="fa-brands fa-twitter"></i> Twitter
                  </label>
                  <input
                    type="url"
                    name="twitterURL"
                    id="twitter"
                    value={inputs.twitterURL}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                    placeholder="Twitter URL"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Add Time Preference */}
          <TimePreference />
          <button type="submit" className="cust-btn create-btn">
            Create an Account
          </button>
        </form>
      </div>
    </>
  );
};

export default InterviewerProfileForm;
